export default "__VITE_ASSET__0L4iPpks__"